<div class="modal-box merge-client-modal" cdkDrag>
    <form class="merge-client-modal__form modal-form" [formGroup]="addClientForm" (ngSubmit)="onSubmit()">
        <div class="modal-header merge-client-modal__header" cdkDragHandle>
            <div class="merge-client-modal__headline modal-headline">
                <span class="merge-client-modal__eyebrow modal-eyebrow">{{ 'CLIENT' | translate }}</span>
                <h4 class="modal-title merge-client-modal__title modal-heading">{{ 'MERGE_CLIENTS' | translate }}</h4>
                <p class="merge-client-modal__subtitle" *ngIf="step==1">{{ 'MERGE_CLIENTS_STEP_1' | translate }}</p>
                <p class="merge-client-modal__subtitle" *ngIf="step==2">{{ 'MERGE_CLIENTS_STEP_2' | translate }}</p>
            </div>
            <button type="button" class="merge-client-modal__close modal-close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body merge-client-modal__body" *ngIf="step==1">
            <div class="merge-client-modal__sections merge-client-modal__sections--single modal-sections">
                <section class="merge-client-modal__panel modal-panel">
                    <div class="merge-client-modal__panel-header modal-panel-header">
                        <span class="merge-client-modal__panel-eyebrow modal-panel-eyebrow">{{ 'COMPARE' | translate }}</span>
                        <h5 class="merge-client-modal__panel-title modal-panel-title">{{ 'CHOOSE_PRIMARY_RECORD_AND_FIELD_VALUES' | translate }}</h5>
                    </div>

                    <div class="merge-client-modal__comparison-shell">
                        <table class="table merge-client-modal__table">
                            <thead>
                                <tr>
                                    <th class="merge-client-modal__label-column"><label>{{ 'PRIMARY_RECORD' | translate }}</label></th>
                                    <th *ngFor="let client of clients">
                                        <div class="merge-client-modal__column-header">
                                            <label class="merge-client-modal__radio-label">
                                                <input type="radio" [value]="client.id" formControlName="id" (click)="setPrimaryRecord(client.id)">
                                                <span>{{ (client.firstName || '') + ' ' + (client.lastName || '') }}</span>
                                            </label>
                                            <button type="button" (click)="setPrimaryRecord(client.id)" class="merge-client-modal__select-all">
                                                {{ 'SELECT_ALL' | translate }}
                                            </button>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th class="merge-client-modal__label-column"><label>{{ 'FIRST_NAME' | translate }}</label></th>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.firstName" formControlName="firstName">
                                            <span>{{ client.firstName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'LAST_NAME' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.lastName" formControlName="lastName">
                                            <span>{{ client.lastName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'ADDRESS' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.brandAddress" formControlName="brandAddress">
                                            <span>{{ client.brandAddress }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'COMPANY' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.brandId" formControlName="brandId">
                                            <span>{{ client.brand }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'DMS' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.dmsId" formControlName="dmsId">
                                            <span>{{ client.dmsName }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'SALES_REP' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.salesRepId" formControlName="salesRepId">
                                            <span>{{ client.salesRep }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'PHONE' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.phone" formControlName="phone">
                                            <span>{{ client.phone }}</span>
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="merge-client-modal__label-column"><label>{{ 'EMAIL' | translate }}</label></td>
                                    <td *ngFor="let client of clients">
                                        <label class="merge-client-modal__radio-label">
                                            <input type="radio" [value]="client.email" formControlName="email">
                                            <span>{{ client.email }}</span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-body merge-client-modal__body" *ngIf="step == 2">
            <div class="merge-client-modal__sections merge-client-modal__sections--single modal-sections">
                <section class="merge-client-modal__panel modal-panel">
                    <div class="merge-client-modal__panel-header modal-panel-header">
                        <span class="merge-client-modal__panel-eyebrow modal-panel-eyebrow">{{ 'PROFILE' | translate }}</span>
                        <h5 class="merge-client-modal__panel-title modal-panel-title">{{ 'MERGED_CLIENT_DETAILS' | translate }}</h5>
                    </div>

                    <div class="merge-client-modal__grid merge-client-modal__grid--single modal-grid">
                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="firstName">{{ 'FIRST_NAME' | translate }}</label>
                            <input id="firstName" type="text" class="form-control merge-client-modal__control" formControlName="firstName"
                                [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" [placeholder]="'ENTER_FIRST_NAME' | translate">
                            <div *ngIf="submitted && f.firstName.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.firstName.errors.required">{{ 'FIRST_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="lastName">{{ 'LAST_NAME' | translate }}</label>
                            <input id="lastName" type="text" class="form-control merge-client-modal__control" formControlName="lastName"
                                [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" [placeholder]="'ENTER_LAST_NAME' | translate">
                            <div *ngIf="submitted && f.lastName.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.lastName.errors.required">{{ 'LAST_NAME_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field merge-client-modal__field--span-2">
                            <label class="merge-client-modal__label" for="brandAddress">{{ 'ADDRESS' | translate }}</label>
                            <textarea id="brandAddress" rows="3" class="form-control merge-client-modal__control merge-client-modal__control--textarea" formControlName="brandAddress"
                                [ngClass]="{ 'is-invalid': submitted && f.brandAddress.errors }" [placeholder]="'ENTER_ADDRESS_INFO' | translate"></textarea>
                            <div *ngIf="submitted && f.brandAddress.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.brandAddress.errors.required">{{ 'ADDRESS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="phone">{{ 'PHONE' | translate }}</label>
                            <input id="phone" type="tel" class="form-control merge-client-modal__control" formControlName="phone"
                                [ngClass]="{ 'is-invalid': submitted && f.phone.errors }" [placeholder]="'ENTER_PHONE_NUMBER' | translate">
                            <div *ngIf="submitted && f.phone.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.phone.errors.required">{{ 'PHONE_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="email">{{ 'EMAIL' | translate }}</label>
                            <input id="email" type="text" class="form-control merge-client-modal__control" formControlName="email"
                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [placeholder]="'ENTER_EMAIL_ADDRESS' | translate">
                            <div *ngIf="submitted && f.email.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.email.errors.required">{{ 'EMAIL_REQUIRED' | translate }}</div>
                                <div *ngIf="f.email.errors.email">{{ 'EMAIL_INVALID' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>

                <section class="merge-client-modal__panel modal-panel">
                    <div class="merge-client-modal__panel-header modal-panel-header">
                        <span class="merge-client-modal__panel-eyebrow modal-panel-eyebrow">{{ 'ASSIGNMENT' | translate }}</span>
                        <h5 class="merge-client-modal__panel-title modal-panel-title">{{ 'COMPANY_AND_OWNERSHIP' | translate }}</h5>
                    </div>

                    <div class="merge-client-modal__grid merge-client-modal__grid--single modal-grid">
                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="brandId">{{ 'COMPANY' | translate }}</label>
                            <ng-select id="brandId" class="merge-client-modal__select" [ngClass]="{ 'is-invalid': submitted && f.brandId.errors }" formControlName="brandId">
                                <ng-option *ngFor="let comp of allCompanies" [value]="comp.id">{{ comp.name }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.brandId.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.brandId.errors.required">{{ 'COMPANY_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field">
                            <label class="merge-client-modal__label" for="dmsId">{{ 'DMS' | translate }}</label>
                            <ng-select id="dmsId" class="merge-client-modal__select" [ngClass]="{ 'is-invalid': submitted && f.dmsId.errors }" formControlName="dmsId">
                                <ng-option *ngFor="let dms of allDms" [value]="dms.id">{{ dms.firstName }} {{ dms.lastName }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.dmsId.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.dmsId.errors.required">{{ 'DMS_REQUIRED' | translate }}</div>
                            </div>
                        </div>

                        <div class="merge-client-modal__field merge-client-modal__field--span-2">
                            <label class="merge-client-modal__label" for="salesRepId">{{ 'SALES_REP' | translate }}</label>
                            <ng-select id="salesRepId" class="merge-client-modal__select" [ngClass]="{ 'is-invalid': submitted && f.salesRepId.errors }" formControlName="salesRepId">
                                <ng-option *ngFor="let rep of allSalesReps" [value]="rep.id">{{ rep.firstName }} {{ rep.lastName }}</ng-option>
                            </ng-select>
                            <div *ngIf="submitted && f.salesRepId.errors" class="merge-client-modal__feedback">
                                <div *ngIf="f.salesRepId.errors.required">{{ 'SALES_REP_REQUIRED' | translate }}</div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <div class="modal-footer merge-client-modal__footer" *ngIf="step==1" cdkDragHandle>
            <div class="merge-client-modal__actions modal-actions">
                <button type="button" class="red-outline-button merge-client-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button [disabled]="!(addClientForm.value.id)" type="button" class="blue-button merge-client-modal__button modal-button" (click)="nextStep()" [attr.title]="'SELECT_PRIMARY_RECORD_TO_PROCEED' | translate">{{ 'NEXT' | translate }}</button>
            </div>
        </div>

        <div class="modal-footer merge-client-modal__footer" *ngIf="step==2" cdkDragHandle>
            <div class="merge-client-modal__actions modal-actions">
                <button type="button" class="red-outline-button merge-client-modal__button modal-button" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
                <button type="button" class="blue-button merge-client-modal__button modal-button" (click)="previousStep()">{{ 'BACK' | translate }}</button>
                <button type="submit" class="orange-button merge-client-modal__button modal-button">{{ 'SAVE' | translate }}</button>
            </div>
        </div>
    </form>
</div>
